import { MA_TYPE } from "../indicatorTypes";
import { fillMovingAverage } from "./movingAverages";

/**
 * True range of a bar as TV Std.tr: the largest of high − low and the gaps
 * to the previous close. The first bar has no previous close, so no value,
 * and averages of the true range start one bar later.
 *
 * @param {object[]} bars
 * @returns {(index: number) => number}
 */
export const trueRangeReader = (bars) => (index) => {
  if (index < 1) return NaN;

  const { high, low } = bars[index];
  const previousClose = bars[index - 1].close;

  return Math.max(high - low, Math.abs(high - previousClose), Math.abs(low - previousClose));
};

/**
 * Average true range as TV Std.atr: the Wilder (RMA) average of the true range.
 *
 * @param {object} params
 * @param {object[]} params.bars
 * @param {number[]} params.target - values before `fromIndex` stay and seed the average
 * @param {number} params.period
 * @param {number} params.fromIndex
 */
export const fillAverageTrueRange = ({ bars, target, period, fromIndex }) => {
  fillMovingAverage({
    type: MA_TYPE.SMMA,
    read: trueRangeReader(bars),
    target,
    period,
    fromIndex,
    toIndex: bars.length,
  });
};
